<template>
  <div>
    <vx-card class="mb-4">
      <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-group
              :label="$t('payment_gateway.active')"
              label-for="gateway">
              <small class="text-muted d-block mb-2">{{ $t('payment_gateway.active_help') }}</small>
              <b-form-radio-group
                id="gateway"
                v-model="selected"
                stacked>
                <b-form-radio
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                  :disabled="!option.configured">
                  <span class="align-middle mr-2">{{ option.label }}</span>
                  <vs-chip
                    transparent
                    :color="option.configured ? 'success' : 'danger'"
                    class="text-base">
                    {{ option.configured ? $t('payment_gateway.configured') : $t('payment_gateway.not_configured') }}
                  </vs-chip>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </div>

        <div class="vx-row" v-if="hasUnconfigured">
          <div class="vx-col w-full">
            <b-alert variant="warning" show class="p-1">
              {{ $t('payment_gateway.not_configured_warning') }}
            </b-alert>
          </div>
        </div>

        <div class="vx-row" v-if="selected && selected !== activeGateway">
          <div class="vx-col w-full">
            <b-alert variant="warning" show class="p-1">
              {{ $t('payment_gateway.switch_warning') }}
            </b-alert>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-end">
            <b-button
              v-permission="'payment_gateway.edit'"
              variant="primary"
              type="submit"
              :disabled="!selected || selected === activeGateway">
              {{ $t('payment_gateway.save') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </vx-card>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BForm,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
} from 'bootstrap-vue'

import PaymentGatewaySettingsService from '@/services/api/PaymentGatewaySettingsService'

export default {
  components: {
    BAlert,
    BButton,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormRadioGroup,
  },

  data() {
    return {
      service: null,
      selected: null,
      activeGateway: null,
      options: [],
    }
  },

  computed: {
    hasUnconfigured() {
      return this.options.some(option => !option.configured)
    },
  },

  methods: {
    applySettings(data) {
      this.activeGateway = data.active_gateway
      this.selected = data.active_gateway
      this.options = data.options || []
    },

    load() {
      this.$vs.loading()
      return this.service
        .load()
        .then(data => this.applySettings(data))
        .catch(error => this.showErrors(null, error, this))
        .finally(() => this.$vs.loading.close())
    },

    save() {
      this.$vs.loading()
      return this.service
        .save(this.selected)
        .then(data => {
          this.applySettings(data)
          const failed = Object.keys(data.plans_failed || {})
          if (failed.length) {
            this.notifyWarning(
              this.$vs,
              this.$t('payment_gateway.plans_partially_synced', { ids: failed.join(', ') }),
              6000
            )
          } else {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
          }
        })
        .catch(error => this.showErrors(null, error, this))
        .finally(() => this.$vs.loading.close())
    },
  },

  beforeMount() {
    this.service = PaymentGatewaySettingsService.build(this.$vs)
  },

  mounted() {
    this.load()
  },
}
</script>
